// src/admin/legal/legalFields.jsx — the fields both legal modals share (v219): the two website links and the PDF
// picker, plus the inline field error. Text inputs (inputMode url) and `noValidate` forms: the browser's own
// validation bubbles would speak their own language; the model checks and our copy words it.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { inputStyle, labelStyle, hintStyle, fieldErrorStyle, fieldStyle } from './legalFormStyles.js';

export function FieldError({ text }) {
  if (!text) return null;
  return <span role="alert" style={fieldErrorStyle}>{text}</span>;
}

export function LinkFields({ url, pdfUrl, onUrl, onPdfUrl, problems }) {
  const { t } = useTranslation('admin');
  return (
    <>
      <div style={fieldStyle}>
        <label htmlFor="lv-url" style={labelStyle}>{t('legalDocuments.form.url')}</label>
        <input id="lv-url" type="text" inputMode="url" value={url} onChange={(e) => onUrl(e.target.value)}
          style={inputStyle} autoComplete="off" placeholder="https://" />
        <span style={hintStyle}>{t('legalDocuments.form.urlHint')}</span>
        <FieldError text={problems.url} />
      </div>
      <div style={fieldStyle}>
        <label htmlFor="lv-pdf-url" style={labelStyle}>{t('legalDocuments.form.pdfUrl')}</label>
        <input id="lv-pdf-url" type="text" inputMode="url" value={pdfUrl} onChange={(e) => onPdfUrl(e.target.value)}
          style={inputStyle} autoComplete="off" placeholder="https://" />
        <span style={hintStyle}>{t('legalDocuments.form.pdfUrlHint')}</span>
        <FieldError text={problems.pdfUrl} />
        <FieldError text={problems.links} />
      </div>
    </>
  );
}

export function PdfField({ file, onFile, hintKey, problem }) {
  const { t } = useTranslation('admin');
  return (
    <div style={fieldStyle}>
      <label htmlFor="lv-file" style={labelStyle}>{t('legalDocuments.form.file')}</label>
      <input id="lv-file" type="file" accept=".pdf,application/pdf"
        onChange={(e) => onFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)} />
      {file && <span style={hintStyle}>{file.name}</span>}
      <span style={hintStyle}>{t(hintKey)}</span>
      <FieldError text={problem} />
    </div>
  );
}
